import {
  PROPERTY_SEARCH_ACTION,
  PROPERTY_SEARCH_COMPLETE,
  PROPERTY_SEARCH_TOGGLE_SECTION,
} from '../actions/filter';

const initialState = {
  inputValue: '',
  lastInputValue: '',
  filteredCore: [],
  filteredSections: [],
  filteredValues: {},
  disabledExpansions: [],
  categoryId: undefined,
};

export default (state, action) => {
  if (!state) {
    return initialState;
  }

  switch (action.type) {
    case 'ROUTE_LOADED': {
      if (action.route && action.route.name === 'category') {
        const category = action.data && action.data.category;
        const categoryId = category && category.id;

        if (state.categoryId === categoryId) {
          return state;
        }

        return { ...initialState, categoryId };
      }

      return state;
    }

    case PROPERTY_SEARCH_ACTION: {
      return {
        ...state,
        lastInputValue: state.inputValue,
        inputValue: action.inputValue,
      };
    }
    case PROPERTY_SEARCH_TOGGLE_SECTION: {
      if (state.disabledExpansions.includes(action.name)) {
        return {
          ...state,
          disabledExpansions: state.disabledExpansions.filter(
            name => name !== action.name
          ),
        };
      }

      return {
        ...state,
        disabledExpansions: [...state.disabledExpansions, action.name],
      };
    }

    case PROPERTY_SEARCH_COMPLETE: {
      return {
        ...state,
        filteredCore: action.filteredCore,
        filteredSections: action.filteredSections,
        filteredValues: action.filteredValues,
      };
    }

    default: {
      return state;
    }
  }
};
